module.exports = __webpack_public_path__ + "img/warehouse-active-subnav.c0021954.svg";